<template>
  <div class="default-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Default'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layouts/Default.vue